import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import { Expaned } from '@/components/layout/layout'

import './stock-return-purchase.scss'
import StockReturnTabel from './stock-return-table/stock-return-table'
import { DatePicker } from 'antd'

const StockReturn = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('stock-return-purchase', e, m)

    const [date, setDate] = useState<string[]>([])

    return (
        <>
            <Expaned className={getCls()}>
                <div className={getCls('header')}>
                    <div
                        className="time-picker"
                        style={{
                            marginLeft: '16px',
                        }}
                    >
                        <DatePicker.RangePicker
                            dateRender={current => (
                                <div
                                    className="ant-picker-cell-inner"
                                    style={{
                                        borderRadius: '50%',
                                    }}
                                >
                                    {current.date()}
                                </div>
                            )}
                            onChange={(monent, dateString) => {
                                setDate(dateString[0] ? dateString : [])
                            }}
                            suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                        />
                    </div>
                </div>
                <Expaned data-row className={getCls('content')}>
                    <StockReturnTabel date={date} />
                </Expaned>
            </Expaned>
        </>
    )
}

export default StockReturn
